




import Vue from 'vue'
import Splash from '../components/Splash.vue'

export default Vue.extend({
  components: {
    Splash
  },
  created: function () {
    this.$store.state.showTopNavigation = false
    let _this = this
    setTimeout(function () {
      if (_this.$store.state.loginUser == null) {
        _this.$store.state.showTopNavigation = true
        _this.$router.push({ path: 'tutorial' })
        // CHATBOX
      } else {
        // INTRO
      }
    }, 3000)
  }
})
